import React from 'react';
import { config } from '_helpers';

const propTypes = {};

const defaultProps = {};

const DefaultFooter = () => (
  <>
    <span>
      <a href='http://www.crdigital.com'>Orion</a>
      {' '}

      &copy; 2023 CR Powered by Epiroc.
    </span>
    <span id='span-build-vers' style={{ opacity: 0.8, fontSize: '80%', marginLeft: 'auto' }}>
      {config.buildVers || '1.0'}
    </span>
  </>
);

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
